import Service from "@/utils/api/service";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import _debounce from "lodash.debounce";

export default {
  name: "EditBranch",
  components: {
    Multiselect,
  },
  data() {
    return {
      isCreating: false,
      body: {
        subId: null,
        warehouseId: null,
        name: "",
        description: "",
        provinceIds: [],
        latitude: null,
        longitude: null,
      },
      items: [],
      allItems: [],
      debouncedOnSearchProvinces: null,

      warehouses: this.$master?.warehouses || [],
      allWarehouses: this.$master?.warehouses || [],
      debouncedOnSearchWarehouses: null,
    };
  },
  computed: {
    ...mapState(["permissions"]),
  },
  created() {
    this.getProvince();
    this.getBranch();
    this.debouncedOnSearchProvinces = _debounce(this.handleSearchChange, 500);
    this.debouncedOnSearchWarehouses = _debounce(
      this.handleWarehouseSearchChange,
      500
    );
  },
  methods: {
    goBack() {
      this.$router.push({ name: "ListBranch" });
    },

    checkoutPermission(permissionName) {
      return this.permissions?.some((group) =>
        group.permissions?.some((p) => p.name === permissionName)
      );
    },

    handleSearchChange(query) {
      if (!query || query.trim() === "") {
        this.items = [...this.allItems];
        return;
      }

      this.filterLocations(this.allItems, query);
    },

    filterLocations(data, search) {
      if (!search || search.trim() === "") {
        this.items = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.items = items;
    },

    handleWarehouseSearchChange(query) {
      if (!query || query.trim() === "") {
        this.warehouses = [...this.allWarehouses];
        return;
      }

      this.filterWarehouse(this.allWarehouses, query);
    },

    filterWarehouse(data, search) {
      if (!search || search.trim() === "") {
        this.warehouses = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.warehouses = items;
    },

    getProvince() {
      const params = "?countryId=1&all=true";

      Service.getProvince(params).then((response) => {
        if (response?.statusCode) {
          if (response.statusCode === "4410") {
            Service.refreshToken().then((result) => {
              if (result === "ok") {
                this.getProvince();
              }
            });
          } else {
            this.$toasted.show(this.capitalize(response.message));
          }
        } else {
          this.allItems = response.data || [];
          this.items = [...this.allItems];
        }
      });
    },

    getWarehouses(search) {
      if (!this.checkoutPermission("VIEW_WAREHOUSE")) return;

      const newSearch = search ? "&search=" + search : "";
      const params = "?limit=10&offset=0" + newSearch;

      Service.getWarehouses(params).then((response) => {
        if (response?.statusCode) {
          if (response.statusCode === "4410") {
            Service.refreshToken().then((result) => {
              if (result === "ok") {
                this.getWarehouses();
              }
            });
          } else {
            this.$toasted.show(this.capitalize(response.message));
          }
        } else {
          this.allWarehouses = response.data || [];
          this.warehouses = [...this.allWarehouses];
        }
      });
    },

    getBranch() {
      Service.getBranch(this.$route.query.id).then((response) => {
        if (response?.statusCode) {
          if (response.statusCode === "4410") {
            Service.refreshToken().then((result) => {
              if (result === "ok") {
                this.getBranch();
              }
            });
          } else {
            this.$toasted.show(this.capitalize(response.message));
          }
        } else {
          this.body = {
            subId: response?.data?.subId || null,
            warehouseId: response?.data?.warehouse || null,
            name: response?.data?.name || "",
            description: response?.data?.description || "",
            provinceIds: response?.data?.provinces || [],
            latitude: response?.data?.latitude || null,
            longitude: response?.data?.longitude || null,
          };
        }
      });
    },

    onSubmit() {
      const validatedMessage = this.validateBody(this.body);

      if (validatedMessage === "ok") {
        this.isCreating = true;
        this.onConfirm();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(data) {
      if (!data.subId) return "Code cannot be empty!";
      // if (!data.warehouseId) return "Warehouse cannot be empty!";
      if (!data.provinceIds?.length) return "Province cannot be empty!";
      if (!data.latitude) return "Latitude cannot be empty!";
      if (!data.longitude) return "Longitude cannot be empty!";
      return "ok";
    },

    onConfirm() {
      const body = {
        ...this.body,
        provinceIds: this.body.provinceIds,
        warehouseId: this.body.warehouseId?.id || "",
      };
      body.provinceIds = body.provinceIds.map((item) => item.id);

      if (!body.warehouseId) {
        delete body.warehouseId;
      }

      Service.updateBranch(this.$route.query.id, body).then((response) => {
        if (response.statusCode) {
          if (response.statusCode === "4410") {
            Service.refreshToken().then((result) => {
              if (result === "ok") {
                this.onConfirm();
              }
            });
          } else {
            this.isCreating = false;
            this.$toasted.show(this.capitalize(response.message));
          }
        } else {
          this.isCreating = false;
          this.goBack();
          this.$toasted.show("Branch has been updated.");
        }
      });
    },

    resetBody() {
      this.body = {
        subId: null,
        warehouseId: null,
        name: "",
        description: "",
        provinceIds: [],
        latitude: null,
        longitude: null,
      };
    },

    capitalize(msg) {
      return msg ? msg.charAt(0).toUpperCase() + msg.slice(1) : "";
    },
  },
};
